<script>
import Icon from './Icon.vue';

export default {
  components: { Icon },

  props: {
    dismissible: {
      type: Boolean,
      default: false,
    },

    class: {
      type: String,
      default: 'primary',
    },

    messageClass: {
      type: String,
      default: 'alert-message',
    },

    icon: {
      type: String,
      default: '',
    },
  },

  emits: ['dismissed'],

  computed: {
    alertClass() {
      let class_name = 'alert-' + this.class;
      if (this.dismissible) {
        class_name += ' alert-dismissible';
      }
      return class_name;
    },
  },
};
</script>

<template>
  <div class="alert" :class="alertClass" role="alert">
    <button
      v-if="dismissible"
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      aria-label="Close"
      @click="$emit('dismissed')"
    />
    <div v-if="icon !== null && icon.length > 0" class="alert-icon">
      <Icon :class-name="icon" />
    </div>
    <div :class="messageClass">
      <slot />
    </div>
  </div>
</template>
